export const WorkspacesUserActionType = {
  WORKSPACE_EDIT: 'actions/policyserver/roleBindings/UPDATE',
  WORKSPACE_DELETE: 'actions/workspaceserver/workspaces/DELETE',
};
